import { useEffect, useState } from "react";
import Footer from "../../components/footer"
import Navbar from "../../components/hero/components/navbar"
import TalentRequisition from "../../components/talent-requisition/TalentRequisition"






export const TalentRequisitionFormPage = () => {

  const [title, setTitle] = useState(`Eratek | Talent Requisition Form`);

  useEffect(() => {
    document.title = title;
    setTitle(title);
  }, [title]);



  return (
    <>
      <Navbar />
      <TalentRequisition />
      <Footer />
    </>
  )
}